import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { LanguageProvider } from './contexts/LanguageContext';
import { CurrencyProvider } from './contexts/CurrencyContext';
import { CartProvider } from './contexts/CartContext';
import { AuthProvider } from './contexts/AuthContext';
import Footer from './components/Footer';
import Home from './pages/Home';
import ItemDetails from './pages/ItemDetails';

import Register from './pages/Register';
import Login from './pages/Login';
import ProductRequest from './pages/ProductRequest';
import AddItemToStore from './pages/AddItemToStore';
import Cart from './pages/Cart';
import Promo from './pages/Promo';
import Profile from './pages/Profile';
import { initGoogleAnalytics, trackPageView } from './analytics';

const AnalyticsListener = () => {
  const location = useLocation();

  useEffect(() => {
    initGoogleAnalytics();
  }, []);

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);

  return null;
};

function App() {
  return (
    <Router>
      <AnalyticsListener />
      <LanguageProvider>
        <CurrencyProvider>
          <CartProvider>
            <AuthProvider>
              <div className="App">
                <main style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/item/:id" element={<ItemDetails />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/product-request" element={<ProductRequest />} />
                    <Route path="/add-item" element={<AddItemToStore />} />
                    <Route path="/cart" element={<Cart />} />
                    <Route path="/promo" element={<Promo />} />
                    <Route path="/profile" element={<Profile />} />
                  </Routes>
                </main>
                <Footer />
              </div>
            </AuthProvider>
          </CartProvider>
        </CurrencyProvider>
      </LanguageProvider>
    </Router>
  );
}

export default App;
